













import { Vue, Watch, Component, Prop } from 'vue-property-decorator'

@Component({
  components: {
  }
})
export default class News extends Vue {
  @Prop(Array) readonly years!: any

  get queryYear () {
    let year = this.$route.query.year
    if (!year) {
      year = '全部'
    }
    return year
  }
  mounted () {
  }
  goYearNews (item:string) {
    console.log('点击年', item)
    this.$emit('changedYear', item)
  }
}
